import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import qs from "query-string";
import { mapKeys } from "./object.js";
import { newApiError } from "../errors/errors.js";
import { contentTypes } from "./http.js";
export var sendRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(request, context) {
    var _request$body;
    var fetch, config, queryString, path, contentType, localHeader, fragments, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(request.body && !request.contentType)) {
            _context.next = 2;
            break;
          }
          throw new Error("sendRequest: contentType is required when body is defined. Request: ".concat(JSON.stringify(request)));
        case 2:
          fetch = context.fetch, config = context.config;
          queryString = qs.stringify(request.query);
          path = queryString ? request.path + "?" + queryString : request.path;
          contentType = request.contentType || contentTypes.none;
          localHeader = {
            "AMS-API-KEY": config.amsApiKey,
            "Content-Type": contentType.header
          };
          if (request !== null && request !== void 0 && (_request$body = request.body) !== null && _request$body !== void 0 && _request$body.language && request.body.language.length > 0) {
            fragments = request.body.language.split('-');
            if (Array.isArray(fragments) && fragments.length === 2) {
              localHeader["accept-language"] = "".concat(fragments[0].toLowerCase(), "-").concat(fragments[1].toUpperCase());
            }
          }
          _context.next = 10;
          return fetch("".concat(config.amsBaseUrl, "/").concat(path), {
            method: request.method,
            credentials: "include",
            headers: localHeader,
            body: contentType.stringify(request.body)
          });
        case 10:
          response = _context.sent;
          if (response.ok) {
            _context.next = 15;
            break;
          }
          _context.next = 14;
          return newApiError(request, response);
        case 14:
          throw _context.sent;
        case 15:
          return _context.abrupt("return", response);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function sendRequest(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var newAmsFetch = function newAmsFetch(_ref2) {
  var fetch = _ref2.fetch,
    config = _ref2.config;
  var context = {
    fetch: fetch,
    config: config
  };
  var amsFetch = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", sendRequest(request, context));
          case 1:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function amsFetch(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
  return amsFetch;
};
export var newAmsResponseRawBody = function newAmsResponseRawBody(amsFetch) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(request) {
      var response;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return amsFetch(request);
          case 2:
            response = _context3.sent;
            _context3.prev = 3;
            _context3.next = 6;
            return response.json();
          case 6:
            return _context3.abrupt("return", _context3.sent);
          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](3);
            return _context3.abrupt("return", undefined);
          case 12:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[3, 9]]);
    }));
    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var newAmsResponseData = function newAmsResponseData(amsFetch) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(request) {
      var body;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return newAmsResponseRawBody(amsFetch)(request);
          case 2:
            body = _context4.sent;
            return _context4.abrupt("return", body.data);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var fromDotNotation = function fromDotNotation(string) {
  return string.replace(/\./g, ":");
};
export var toDotNotation = function toDotNotation(string) {
  return string.replace(/:/g, ".");
};
export var objectKeysToDotNotation = function objectKeysToDotNotation(object) {
  return mapKeys(object, toDotNotation);
};
export var isLoginCaptchaError = function isLoginCaptchaError(error) {
  return error.status === 403 && error.responseData.captchaSiteKey !== undefined;
};
export var isCaptchaError = function isCaptchaError(error) {
  var _error$responseData;
  return error.status === 401 && ((_error$responseData = error.responseData) === null || _error$responseData === void 0 ? void 0 : _error$responseData.exceptionType) === "CaptchaException";
};
export var isNotUniqueGuestAccount = function isNotUniqueGuestAccount(error) {
  var _error$responseData2;
  return error.status === 500 && ((_error$responseData2 = error.responseData) === null || _error$responseData2 === void 0 ? void 0 : _error$responseData2.exceptionType) === "NotUniqueGuestAccountException";
};
export var isValidationError = function isValidationError(error) {
  return error.status === 500 && error.responseData.exceptionType === "ProcessingException" && Boolean(error.responseData.data) && Object.keys(error.responseData.data).filter(function (key) {
    return key !== ".";
  }).length > 0;
};